import React, { Component } from 'react';
import { API_PATH } from './config.js';

class Retorno extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noticias: [],
      filtradas: [],
      loading: true,
      currentPage: 1,
      noticiasPorPagina: 10,
      search: ""
    };
  }

  componentDidMount() {
    this.cargarNoticias();
  }

  cargarNoticias = async () => {
    this.setState({ loading: true });

    const notas = await this.fetchAllNews();

    this.setState({
      noticias: notas,
      filtradas: notas,   // importante
      loading: false
    });
  };

  async fetchAllNews() {
    let page = 1;
    let allPosts = [];
    let totalPages = 1;

    do {
      const response = await fetch(
        `${API_PATH}nueva_normalidad?per_page=100&page=${page}`
      );

      if (!response.ok) {
        console.error("Error al cargar, status:", response.status);
        break;
      }

      // WordPress envía cuántas páginas existen
      totalPages = parseInt(response.headers.get("X-WP-TotalPages")) || 1;

      const data = await response.json();

      allPosts = [...allPosts, ...data];

      page++;
    } while (page <= totalPages);

    return allPosts;
  }

  handleSearch = (e) => {
    const search = e.target.value.toLowerCase();

    this.setState({ search, currentPage: 1 }, () => {
      const filtradas = this.state.noticias.filter((n) => {
        const titulo = (n.title?.rendered || "").toLowerCase();
        const contenido = (n.content?.rendered || "").toLowerCase();

        return (
          titulo.includes(search) ||
          contenido.includes(search)
        );
      });

      this.setState({ filtradas });
    });
  };

  // Cambiar de página
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  // Función auxiliar para cortar a las primeras 50 palabras
  primeras50 = (texto) => {
    if (!texto) return "";
    if (typeof texto === "object" && texto.rendered) {
      texto = texto.rendered;
    }
    if (typeof texto !== "string") {
      texto = String(texto);
    }
    // Quitar HTML
    const plain = texto.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    const words = plain.split(" ");
    return words.length <= 20 ? plain : words.slice(0, 20).join(" ") + "...";
  };

  formatFecha(fechaWP) {
    const fecha = new Date(fechaWP);
    return fecha.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }


  render() {
    const { filtradas, currentPage, noticiasPorPagina, loading } = this.state;
    if (loading)return <div className="preloader" >
                    <div className="div-transform">
                        <div className="loader">
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                            <div className="face">
                <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>;
    const indexOfLast = currentPage * noticiasPorPagina;
    const indexOfFirst = indexOfLast - noticiasPorPagina;
    const noticiasActuales = filtradas.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filtradas.length / noticiasPorPagina);
    // Crear array de números de página
    const pages = [...Array(totalPages).keys()].map(x => x + 1);

    return (
      <>
        <div className="container-fluid bg-black" >
          <h1 align="center" className="tituloPrincipal"><b>B2N</b></h1>
        </div>
        <br/>
        <div className="container">
          <div className="row dropDownContainer">
            <div className="col-md-6" >
              
            </div>
            <div className="col-md-6 serch-news" >
              <input
                type="text"
                placeholder="Buscar"
                value={this.state.search}
                onChange={this.handleSearch}
                className="search-field"
              />
              <i className="fa fa-search white"></i>
              <hr className="hrb63" />
            </div>
          </div>
        </div>
        <br/>
        <div className="container" >
          {noticiasActuales.map(n => (
          <div  key={n.id} className="row">
            <div className="col-md-6" >
              <img src={n.acf?.imagen}  className="img-card2"/>
            </div>
            <div className="col-md-6" >
              {/* <span className="fecha-n"> {this.formatFecha(n.date)}</span> */}
              <h3  className="message-news-2" dangerouslySetInnerHTML={{ __html: n.title.rendered }} />
             <hr className="hrb4" /><br />  
              <a className="leia-mas" href={`/b2n/${n.id}`} > Ver más</a> <br/> 
            </div> <hr className="hr-sweet" />
          </div>
        ))}
      </div>

        {/* Paginación */}
        <div style={{ marginTop: "20px" }} className='container'>
          {pages.map((num) => (
            <button
              key={num}
              onClick={() => this.handlePageChange(num)}
              style={{
                background: num === currentPage ? "#001747" : "#000",
              }}
              className='btn-pagination'
            >
              {num}
            </button>
          ))}
        </div><br/><br/>
      
      </>
    );
  }
}

export default Retorno;
